import { render, staticRenderFns } from "./PptRectAttr.vue?vue&type=template&id=5c58ce16&"
import script from "./PptRectAttr.vue?vue&type=script&lang=js&"
export * from "./PptRectAttr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/attr/PptRectAttr.vue"
export default component.exports